import React from 'react'

const Lang = () => {
    return (
        <div className='header-lang'>
            <a href="/">RU</a>
        </div>
    )
}

export default Lang
